import { FC } from 'react';
import { asButton } from '@getstream/ui-library/build';

export type Props = {
  onClick?: () => void;
  align?: string;
  size: string;
  color: string;
  shadow?: string;
  disabled?: boolean;
  className?: string;
  to?: string;
  href?: string;
  external?: boolean;
  emphasis?: boolean;
  children?: any;
};

export const Button: FC<Props> = asButton(({ ...props }) => <a {...props} />);
